module.exports = __webpack_public_path__ + "media/images/tutorial_body_sp3-05-2b56f1b898c2a43f90c4f3892b84c797.png";